import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import BarcodeScannerComponent from "react-qr-barcode-scanner";
import { FaAnglesLeft } from "react-icons/fa6";
import { FaAnglesRight } from "react-icons/fa6";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

import CryptoJS from "crypto-js";

const Download = () => {
  const [data, setData] = useState("Not Found");
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const [loadedImagesCount, setLoadedImagesCount] = useState(0);
  const [uniqueIds, setUniqueIds] = useState("");
  const [encryptedText, setencryptedText] = useState("");
  const [isScanning, setIsScanning] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen3, setIsModalOpen3] = useState(false);
  const [moveRight, setMoveRight] = useState(false);
  const [moveLeft1, setMoveLeft1] = useState(false);
  const [messageNew, setMessageNew] = useState("");
  const [messageNewError, setMessageNewError] = useState("");
  const [messageLeft, setMessageLeft] = useState("");
  const [messageLefterror, setMessageLefterror] = useState("");
  const [details, setDetails] = useState([]);
  const [location, setLocation] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [dimensions, setDimensions] = useState({ width: 640, height: 480 });

  useEffect(() => {
    const handleResize = () => {
      setDimensions({
        width: window.innerWidth < 768 ? 670 : 640, // Adjust for small screens
        height: window.innerWidth < 768 ? 510 : 480,
      });
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Set initial dimensions

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const decryptUniqueId = (encryptedText) => {
    const secretKey = "MyS3cr3tK3yF2rEncrypT1on!1234567";

    if (!encryptedText || !encryptedText.includes(":")) {
      console.error("Invalid encrypted text format");
      return "";
    }

    const [ivHex, encryptedHex] = encryptedText.split(":");

    if (!ivHex || !encryptedHex) {
      console.error(
        "Invalid encrypted text format: Missing IV or encrypted data"
      );
      return "";
    }

    try {
      const iv = CryptoJS.enc.Hex.parse(ivHex);
      const encrypted = CryptoJS.enc.Hex.parse(encryptedHex);

      const decryptedBytes = CryptoJS.AES.decrypt(
        { ciphertext: encrypted },
        CryptoJS.enc.Utf8.parse(secretKey),
        { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
      );

      const decryptedText = decryptedBytes.toString(CryptoJS.enc.Utf8);
      return decryptedText || "";
    } catch (error) {
      console.error("Decryption failed:", error);
      return "";
    }
  };

  useEffect(() => {
    if (encryptedText) {
      const decryptedText = decryptUniqueId(encryptedText);
      if (decryptedText && decryptedText !== uniqueIds) {
        setUniqueIds(decryptedText);
      }
    }
  }, [encryptedText]);
  const totalImages = 3;

  // const navigate = useNavigate()
  // const navigate = useNavigate()

  const handleRequestLocation = () => {
    setLoading(true);
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setLocation({ latitude, longitude });
          getCityStateCountry(latitude, longitude);
        },
        (err) => {
          setError(err.message);
          setLoading(false);
          alert(`Error: ${err.message}`);
        }
      );
    } else {
      setError("Geolocation is not supported by this browser.");
      setLoading(false);
      alert("Geolocation is not supported by this browser.");
    }
  };

  // Function to fetch location details using OpenCage API
  const getCityStateCountry = async (lat, lon) => {
    try {
      const apiKey = "63b5ee1d87d049259757b4a408565081"; // 🔹 Your OpenCage API Key
      const response = await axios.get(
        `https://api.opencagedata.com/geocode/v1/json?q=${lat}+${lon}&key=${apiKey}`
      );

      if (response.data.results.length > 0) {
        const result = response.data.results[0];
        const details = result.components;
        const formattedLocation = {
          address: result.formatted || "Unknown Address",
          area:
            details.suburb ||
            details.neighbourhood ||
            details.district ||
            "Unknown Area",
          city: details.city || details.town || details.village || "Unknown",
          state: details.state || "Unknown",
          country: details.country || "Unknown",
          postalCode: details.postcode || "N/A",
        };

        setLocation((prev) => ({ ...prev, ...formattedLocation }));
      } else {
        setError("No address found.");
      }
      setLoading(false);
    } catch (error) {
      setError("Failed to fetch address details.");
      setLoading(false);
    }
  };

  // new scan api

  const newScan = () => {
    setLoading(true);

    const data = {
      unique_id: uniqueIds,
      location: location?.address,
      area: location?.area,
      city: location?.city,
      state: location?.state,
      country: location?.country,
      pincode: location?.postalCode,
    };

    axios
      .post(`${process.env.REACT_APP_BASE_URL}get_new_unique_scan`, data)
      .then((response) => {
        if (response.status === 200 && response.data?.result === "true") {
          setLoading(true);
          scanDetails();
          setMessageNew("");
          setMessageNewError("");
        } else {
          setMessageNew("");
          setMessageNewError("Already Sold or Not Verified or Expired");
        }
      })
      .catch((error) => {
        console.log("New Scan Error:", error);
        setMessageNew("");
        const msg = error?.response?.data?.msg;
        if (
          msg === "User already scanned this QR code." ||
          msg === "Invalid QR, please scan another QR."
        ) {
          setMessageNewError("Already Sold or Not Verified or Expired");
        } else {
          setMessageNewError("Already Sold or Not Verified or Expired");
        }

        if (error?.status === 400) {
          setDetails(null);
        }
      })
      .finally(() => setLoading(false));
  };

  const leftscan = () => {
    const data = {
      unique_id: uniqueIds,
      location: location?.address,
      area: location?.area,
      city: location?.city,
      state: location?.state,
      country: location?.country,
      pincode: location?.postalCode,
    };

    axios
      .post(`${process.env.REACT_APP_BASE_URL}get_new_unique_scan_left`, data)
      .then((response) => {
        if (response?.status === 200 && response?.data?.result === "true") {
          setMessageLeft("Congratulations!!");
          setMessageLefterror("");
        } else {
          setMessageLeft("");
          setMessageLefterror("Already Sold or Not Verified or Expired");
        }
      })
      .catch((error) => {
        setMessageLeft("");
        const msg = error?.response?.data?.msg;
        if (
          msg === "User already scanned this QR code." ||
          msg === "Invalid QR, please scan another QR."
        ) {
          setMessageLefterror("Already Sold or Not Verified or Expired");
        } else {
          setMessageLefterror("Already Sold or Not Verified or Expired");
        }
      })
      .finally(() => {
        setLoading(false); // Stop loading
      });
  };

  // scan details
  const scanDetails = async () => {
    setLoading(true);

    const data = {
      unique_id: uniqueIds,
      location: location?.address,
      area: location?.area,
      city: location?.city,
      state: location?.state,
      country: location?.country,
      pincode: location?.pincode,
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}get_new_unique_scan_right`,
        data
      );
      console.log("Scan Response:", response);
      setDetails(response?.data?.data?.table_data || []);
    } catch (error) {
      console.log("Error:", error);
      if (error?.response?.data) {
        const errorMessage = error.response.data.msg;
        console.error("Error Message:", errorMessage);
      }
    } finally {
      setLoading(false);
    }
  };

  console.log("details", details);

  const handleclose2 = () => {
    setIsModalOpen(false);
    setencryptedText("");
    setUniqueIds("");
    setDetails(null);
    setIsScanning(false);
    setIsOpen(false);
    setMessageLeft(""); // clear success message
    setMessageLefterror(""); // clear error message
    setLoading(false); // just in case it's still true
  };

  const handleclose3 = () => {
    setIsModalOpen3(false);
    setencryptedText("");
    setUniqueIds("");
    setDetails(null);
    setIsScanning(false);
    setIsOpen(false);
  };

  const handlecameraOpen = () => {
    setencryptedText("");
    setUniqueIds("");
    setDetails(null);
    setIsScanning(true);
  };

  const handleclosescaning = () => {
    setencryptedText("");
    setUniqueIds("");
    setDetails(null);
    setMessageLeft("");
    setMessageLefterror("");
    setMessageNew("");
    setMessageNewError("");
    setIsScanning(false);
  };

  console.log("data", uniqueIds);

  const toggleModal = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (uniqueIds) {
      setIsOpen(true);
      setIsScanning(false);
      handleRequestLocation();
    }
  }, [uniqueIds]);

  const handleClick = () => {
    setMoveRight(true);
    setTimeout(() => {
      setIsModalOpen(true);
      setLoading(true);
      setMessageLeft("");
      setMessageLefterror("");
      leftscan();
      setTimeout(() => {
        setMoveRight(false);
      }, 100);
    }, 800);
  };

  const handleClick1 = () => {
    setMoveLeft1(true); // Start animation

    setTimeout(() => {
      setIsModalOpen3(true);
      setLoading(true);
      setMessageNew("");
      setMessageNewError("");
      setDetails(null);
      newScan();
      setTimeout(() => {
        setMoveLeft1(false);
      }, 100);
    }, 800);
  };

  const handleAllmodelclose1 = () => {
    setIsModalOpen(false);
    setMessageLeft("");
    setMessageLefterror("");
    setLoading(false);
    setIsOpen(false);
    setIsScanning(true);
    setencryptedText("");
    setUniqueIds("");
    setDetails(null);
  };

  const handleAllmodelclose2 = () => {
    setencryptedText("");
    setUniqueIds("");
    setDetails(null);
    setIsScanning(true);
    setIsModalOpen3(false);
    setIsOpen(false);
  };


  useEffect(() => {
    AOS.init({ duration: 1500, once: true });

    const loader = document.getElementById("preloader");
    if (loader) {
      setTimeout(() => {
        loader.style.display = "none";

        // Init OwlCarousel from here
        if (window.$ && window.$("#screen_slider").owlCarousel) {
          window.$("#screen_slider").owlCarousel({
            loop: true,
            margin: 10,
            nav: true,
            dots: true,
            autoplay: true,
            autoplayTimeout: 2500,
            autoplaySpeed: 1000,
            autoplayHoverPause: true,
            center: true,
            stagePadding: 50,
            responsive: {
              0: { items: 1, stagePadding: 30 },
              600: { items: 3, stagePadding: 50 },
              1000: { items: 5, stagePadding: 80 },
            },
          });
        }

        AOS.refresh(); // Recalculate animations
      }, 1000); // Wait for loader
    }
  }, []);
  // slide one 
  // Function to handle image load
  const handleImageLoad = () => {
    setLoadedImagesCount((prev) => prev + 1);
  };

  useEffect(() => {
    // If all images are loaded, initialize Owl Carousel
    if (loadedImagesCount === totalImages) {
      setImagesLoaded(true);

      setTimeout(() => {
        if (window.$ && window.$("#frmae_slider").owlCarousel) {
          window.$("#frmae_slider").owlCarousel({
            loop: true,
            margin: 10,
            nav: false,
            dots: false,
            autoplay: true,
            autoplayTimeout: 3000,
            autoplayHoverPause: true,
            items: 1,
          });
        }
      }, 500); // Slight delay to ensure DOM is ready
    }
  }, [loadedImagesCount]); // Trigger when the number of loaded images changes
  return (
    <>
      <div>
        <div>
          <div className="page_wrapper">
            <div id="preloader">
              <div id="loader" />
            </div>
            {/* Header Start */}
            <header>
              {/* container start */}
              <div className="container">
                {/* navigation bar */}
                <nav className="navbar navbar-expand-lg">
                  <a className="navbar-brand" href="#">
                    <img src="images/Logosmall.png" alt="image" />

                    <div className=" banner_text">
                      <h2
                        style={{
                          "margin-top": "0",
                          marginLeft: "0px",
                          fontSize: "14px",
                        }}>
                        Buy original with <span>OriVeri </span>
                      </h2>

                      {/* <p>
                        Protect your Customers your Brand. It’s Reputation &amp;
                        Sales
                      </p> */}
                    </div>
                  </a>
                  <button
                    className="navbar-toggler"
                    type="button"
                    data-toggle="collapse"
                    data-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon">
                      {/* <i class="icofont-navigation-menu ico_menu"></i> */}
                      <div className="toggle-wrap">
                        <span className="toggle-bar" />
                      </div>
                    </span>
                  </button>
                  <div
                    className="collapse navbar-collapse"
                    id="navbarSupportedContent">
                    <ul className="navbar-nav ml-auto">
                      {/* secondery menu start */}
                      <li className="nav-item has_dropdown">
                        <Link to={"/"} className="nav-link" href="#">
                          Home
                        </Link>
                      </li>

                      <li className="nav-item">
                        <a className="nav-link" href="#how_it_work">
                          How it works
                        </a>
                      </li>

                      <li className="nav-item">
                        <Link to={"/scanqr"} className="nav-link" href="#how_it_work">
                          Scan QR
                        </Link>
                      </li>
                    </ul>
                  </div>
                </nav>
                {/* navigation end */}
              </div>
              {/* container end */}
            </header>

            {/* Banner-Section-Start */}
            <section className="banner_section ">
              {/* container start */}
              <div className="container">
                {/* vertical animation line */}
                <div className="anim_line">
                  <span>
                    <img src="images/anim_line.png" alt="anim_line" />
                  </span>
                  <span>
                    <img src="images/anim_line.png" alt="anim_line" />
                  </span>
                  <span>
                    <img src="images/anim_line.png" alt="anim_line" />
                  </span>
                  <span>
                    <img src="images/anim_line.png" alt="anim_line" />
                  </span>
                  <span>
                    <img src="images/anim_line.png" alt="anim_line" />
                  </span>
                  <span>
                    <img src="images/anim_line.png" alt="anim_line" />
                  </span>
                  <span>
                    <img src="images/anim_line.png" alt="anim_line" />
                  </span>
                  <span>
                    <img src="images/anim_line.png" alt="anim_line" />
                  </span>
                  <span>
                    <img src="images/anim_line.png" alt="anim_line" />
                  </span>
                </div>
                {/* row start */}
                <div className="row">
                  <div
                    className="col-lg-6 col-md-12"
                    data-aos="fade-right"
                    data-aos-duration={1500}
                    style={{ "margin-bottom": "30px", height: "auto" }}>
                    {/* banner text */}
                    <div className="banner_text">
                      <h1 style={{ "margin-top": "-25%" }}>
                        Buy original with <span>OriVeri </span>
                      </h1>
                      {/* h1 */}
                      {/* <h3>Best way to Protect Your <span>Customers & Your Brand</span></h3> */}
                      {/* p */}
                      <p>
                        Protect your Customers your Brand. It’s Reputation &amp;
                        Sales
                      </p>
                    </div>
                    {/* app buttons */}
                    <ul className="app_btn">
                      <li>
                        <a href="https://apps.apple.com/us/app/oriveri/id6741198221">
                          <img
                            className="blue_img"
                            src="images/appstore_blue.png"
                            alt="image"
                          />
                          <img
                            className="white_img"
                            src="images/appstore_white.png"
                            alt="image"
                          />
                        </a>
                      </li>
                      <li>
                        <a href="https://play.google.com/store/apps/details?id=com.oriveri.com">
                          <img
                            className="blue_img"
                            src="images/googleplay_blue.png"
                            alt="image"
                          />
                          <img
                            className="white_img"
                            src="images/googleplay_white.png"
                            alt="image"
                          />
                        </a>
                      </li>
                    </ul>
                  </div>


                  <div
                    className="col-lg-6 col-md-12"
                    data-aos="fade-in"
                    data-aos-duration={1500}
                    style={{ position: "relative", height: "100px" }}
                  >
                    <div className="banner_slider" style={{ position: "relative" }}>
                      {/* Sliding Image Content */}
                      <div
                        id="frmae_slider"
                        className="owl-carousel owl-theme"
                        style={{
                          overflow: "hidden",
                          position: "absolute",
                          top: "-28px",
                          left: "50%",
                          transform: "translateX(-50%)",
                          width: "262px", // slightly smaller than SVG width
                          height: "590px", // adjusted height
                          zIndex: 2,
                          borderRadius: "28px",
                          visibility: imagesLoaded ? "visible" : "hidden", // Hide until images are loaded
                        }}
                      >
                        {["screen22.png", "screen23.png", "screen24.png"].map((img, index) => (
                          <div className="item" key={index}>
                            <div
                              className="slider_img"
                              style={{
                                width: "100%",
                                height: "100%",
                                overflow: "hidden",
                                padding: "10px",
                                boxSizing: "border-box",
                              }}
                            >
                              <img
                                src={`images/${img}`}
                                alt={`slide-${index}`}
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  borderRadius: "20px",
                                  objectFit: "cover",
                                }}
                                onLoad={handleImageLoad} // Trigger state change when image is loaded
                              />
                            </div>
                          </div>
                        ))}
                      </div>

                      {/* Static Frame on top */}
                      <div
                        className="slider_frame"
                        style={{ position: "relative", zIndex: 3 }}
                      >
                        <img
                          style={{ width: "279px", margin: "0px -3px" }}
                          src="images/mobile_frame_svg.svg"
                          alt="mobile frame"
                        />
                      </div>
                    </div>
                  </div>

                </div>
                {/* row end */}
              </div>
              {/* container end */}
            </section>
            {/* Banner-Section-end */}
            {/* How-It-Workes-Section-Start */}
            <section className="row_am how_it_works" id="how_it_work">
              {/* container start */}
              <div className="container">
                <div className="how_it_inner">
                  <div
                    className="section_title"
                    data-aos="fade-up"
                    data-aos-duration={1500}
                    data-aos-delay={300}>
                    {/* h2 */}
                    <h2>
                      <span>How it works</span> - 3 easy steps
                    </h2>
                    {/* p */}
                    <p>
                      Our platform makes is super easy to identify Counterfeits,
                      Expired or already Sold Products
                    </p>
                  </div>
                  <div className="step_block">
                    {/* UL */}
                    <ul>
                      {/* step */}
                      <li>
                        <div
                          className="step_text"
                          data-aos="fade-right"
                          data-aos-duration={1500}>
                          <h4>Download app</h4>
                          <div className="app_icon">
                            <a href="#">
                              <i className="icofont-brand-android-robot" />
                            </a>
                            <a href="#">
                              <i className="icofont-brand-apple" />
                            </a>
                          </div>
                          <p>Download App either for Android or IOS</p>
                          <p>
                            Sign up free using your moblie number and email ID
                          </p>
                        </div>
                        <div className="step_number">
                          <h3>01</h3>
                        </div>
                        <div
                          className="step_img"
                          data-aos="fade-left"
                          data-aos-duration={1500}>
                          <img src="images/download_app.jpg" alt="image" />
                        </div>
                      </li>
                      {/* step */}
                      <li>
                        <div
                          className="step_text"
                          data-aos="fade-left"
                          data-aos-duration={1500}>
                          <h4>Swipe </h4>
                          {/* <p>To get complet details of the product you are buying </p> */}
                          <p>
                            {" "}
                            Or just Swpie left to know if the product is right !
                          </p>
                        </div>
                        <div className="step_number">
                          <h3>02</h3>
                        </div>
                        <div
                          className="step_img"
                          data-aos="fade-right"
                          data-aos-duration={1500}>
                          <img src="images/create_account.jpg" alt="image" />
                        </div>
                      </li>
                      {/* step */}
                      <li>
                        <div
                          className="step_text"
                          data-aos="fade-right"
                          data-aos-duration={1500}>
                          <h4>Get Results Instantly </h4>
                          <p>
                            To get complet details of the product you are buying{" "}
                          </p>
                          {/* <p> Or just Swpie left to know if the product is right !</p> */}
                        </div>
                        <div className="step_number">
                          <h3>03</h3>
                        </div>
                        <div
                          className="step_img"
                          data-aos="fade-left"
                          data-aos-duration={1500}>
                          <img src="images/enjoy_app.jpg" alt="image" />
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* container end */}
            </section>
            {/* <!-- Beautifull-interface-Section start --> */}
            <section class="row_am interface_section">
              <div class="container-fluid">
                <div
                  class="section_title"
                  data-aos="fade-up"
                  data-aos-duration="1500"
                  data-aos-delay="300">
                  <h2>
                    Effective and <span>Efficient Interface</span>
                  </h2>
                </div>

                {/* <!-- screen slider start --> */}

                <div className="screen_slider">
                  <div
                    id="screen_slider"
                    className="owl-carousel owl-theme owl-loaded owl-drag">
                    {/* Slider Items */}
                    <div className="item">
                      <div className="screen_frame_img">
                        <img
                          width={250}
                          src="images/screen-1.png"
                          alt="image"
                        />
                      </div>
                    </div>
                    {/* <div className="item">
                      <div className="screen_frame_img">
                        <img width={250} src="images/screen-2.png" alt="image" />
                      </div>
                    </div> */}
                    <div className="item">
                      <div className="screen_frame_img">
                        <img
                          width={250}
                          src="images/screen-3.png"
                          alt="image"
                        />
                      </div>
                    </div>
                    <div className="item">
                      <div className="screen_frame_img">
                        <img
                          width={250}
                          src="images/screen-4.jpg"
                          alt="image"
                        />
                      </div>
                    </div>
                    <div className="item">
                      <div className="screen_frame_img">
                        <img
                          width={250}
                          src="images/screen-5.jpg"
                          alt="image"
                        />
                      </div>
                    </div>
                    <div className="item">
                      <div className="screen_frame_img">
                        <img
                          width={250}
                          src="images/screen-6.jpg"
                          alt="image"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* <!-- screen slider end --> */}
              </div>
              {/* <!-- container end --> */}
            </section>
            {/* Footer-Section start */}
            <footer>
              <div className="top_footer" id="contact">
                {/* animation line */}
                <div className="anim_line dark_bg">
                  <span>
                    <img src="images/anim_line.png" alt="anim_line" />
                  </span>
                  <span>
                    <img src="images/anim_line.png" alt="anim_line" />
                  </span>
                  <span>
                    <img src="images/anim_line.png" alt="anim_line" />
                  </span>
                  <span>
                    <img src="images/anim_line.png" alt="anim_line" />
                  </span>
                  <span>
                    <img src="images/anim_line.png" alt="anim_line" />
                  </span>
                  <span>
                    <img src="images/anim_line.png" alt="anim_line" />
                  </span>
                  <span>
                    <img src="images/anim_line.png" alt="anim_line" />
                  </span>
                  <span>
                    <img src="images/anim_line.png" alt="anim_line" />
                  </span>
                  <span>
                    <img src="images/anim_line.png" alt="anim_line" />
                  </span>
                </div>
                {/* container start */}
                <div className="container">
                  {/* row start */}
                  <div className="row">
                    {/* footer link 1 */}
                    <div className="col-lg-4">
                      <div className="abt_side">
                        <div className="logo">
                          <img src="images/Logosmall.png" alt="image" />
                        </div>
                        <ul>
                          <li>
                            <a href="#">info@oriveri.com</a>
                          </li>
                          {/* <li><a href="#">+1-900-123 4567</a></li> */}
                        </ul>
                        <ul className="social_media">
                          <li>
                            <a href="#">
                              <i className="icofont-facebook" />
                            </a>
                          </li>
                          <li>
                            <a href="#">
                              <i className="icofont-linkedin" />
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>

 {/* footer link 3 */}
                                          <div className="col-lg-3">
                    <div className="links">
                      <ul>
                        <li>
                          <Link to="/contactowner" style={{ color: "yellow", fontWeight: "bold" }}>
                            For Brand Owners
                          </Link>
                        </li>
                        <li>
                          <Link to="/scanqr" style={{ color: "yellow", fontWeight: "bold" }}>
                            Scan Qr
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>

                    {/* footer link 2 */}
                    <div className="col-lg-3">
                      <div className="links">
                        <ul>
                          <li>
                            <Link to="/contact">Contact us</Link>
                          </li>
                          <li>
                            <Link to="/terms&conditions">Terms &amp; conditions</Link>
                          </li>
                          <li>
                            <Link to="/privacy">Privacy policy</Link>
                          </li>
                        </ul>
                      </div>
                    </div>

                   

                    {/* footer link 4 */}
                    <div className="col-lg-2">
                      <div className="try_out">
                        <div
                          style={{ borderRadius: "10px 10px 0px 0px" }}
                          className="responsive_div"
                        >
                          <h4 className="responsive_heading">
                            <b>Download</b> the <b>Application</b> for a{" "}
                            <b>Secured</b>, <b>Swift</b>, and <b>Smooth experience</b>!
                          </h4>
                          <ul style={{ marginBottom: "0px" }} className="app_btn">
                            <li>
                              <a href="https://apps.apple.com/us/app/oriveri/id6741198221">
                                <img src="images/appstore_blue.png" alt="App Store" />
                              </a>
                            </li>
                            <li>
                              <a href="https://play.google.com/store/apps/details?id=com.oriveri.com">
                                <img
                                  style={{ padding: "3px" }}
                                  src="images/googleplay_blue.png"
                                  alt="Google Play"
                                />
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* row end */}
                </div>
                {/* container end */}
              </div>
              {/* last footer */}
              <div className="bottom_footer">
                {/* container start */}
                <div className="container">
                  {/* row start */}
                  <div className="row">
                    <div className="col-md-6">
                      <p>© Copyrights 2025. All rights reserved.</p>
                    </div>
                    <div className="col-md-6">
                      <p className="developer_text">
                        Design &amp; developed by{" "}
                        <a
                          href="https://themeforest.net/user/kalanidhithemes"
                          target="blank">
                          Logical Softtech Pvt. Ltd.
                        </a>
                      </p>
                    </div>
                  </div>
                  {/* row end */}
                </div>
                {/* container end */}
              </div>
              {/* go top button */}
              <div className="go_top">
                <span>
                  <img src="images/go_top.png" alt="image" />
                </span>
              </div>
            </footer>
            {/* Footer-Section end */}
            {/* VIDEO MODAL */}
            <div
              className="modal fade youtube-video"
              id="myModal"
              tabIndex={-1}
              role="dialog"
              aria-labelledby="myModalLabel">
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <button
                    id="close-video"
                    type="button"
                    className="button btn btn-default text-right"
                    data-dismiss="modal">
                    <i className="icofont-close-line-circled" />
                  </button>
                  <div className="modal-body">
                    <div id="video-container" className="video-container">
                      <iframe
                        id="youtubevideo"
                        src="#"
                        width={640}
                        height={360}
                        frameBorder={0}
                        allowFullScreen
                      />
                    </div>
                  </div>
                  <div className="modal-footer"></div>
                </div>
              </div>
            </div>
            {/* =============================================================================>button fixed */}
            <div className="purple_backdrop" />
          </div>
        </div>
      </div>

      {/* First Modal just checking $ chacking to buy----click */}
      {isOpen && (
        <div className="modal show d-block">
          <div
            style={{ width: "70%", margin: "auto" }}
            className="modal-dialog"
            role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Thank You for Scanning the OriVeri QR
                </h5>
                <button type="button" className="close" onClick={toggleModal}>
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="container mt-4">
                  <div className="row">
                    <div
                      style={{ marginBottom: "50px" }}
                      className="w-100 d-flex align-center justify-content-center ">
                      <img width={180} src="images/Logosmall.png" alt="Logo" />
                    </div>
                    <div className="button-container w-100 d-flex align-center justify-content-center">
                      <button
                        onClick={handleClick}
                        style={{
                          backgroundColor: moveRight ? "#ffcc00" : "#ffd34f",
                          transition: "background-color 0.8s ease",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "190px",
                          position: "relative",
                        }}
                        className="btn p-3 rounded-pill responsive-btn">
                        <span style={{ flex: 1, textAlign: "center" }}>
                          Just Checking
                        </span>
                        <span
                          style={{
                            backgroundColor: "#fcee00",
                            position: "absolute",
                            right: moveRight ? "0px" : "calc(100% - 45px)",
                            transition: "right 0.8s ease",
                            padding: "14px",
                            borderRadius: "50%",
                          }}>
                          <FaAnglesRight />
                        </span>
                      </button>

                      <button
                        onClick={handleClick1}
                        style={{
                          backgroundColor: moveRight ? "#2b6e29" : "#329347",
                          transition: "background-color 0.8s ease",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "190px",
                          position: "relative",
                        }}
                        className="btn p-3 rounded-pill responsive-btn">
                        <span style={{ flex: 1, textAlign: "start" }}>
                          Checking to Buy
                        </span>
                        <span
                          style={{
                            backgroundColor: moveLeft1 ? "#004d0f" : "#005e12",
                            position: "absolute",
                            left: moveLeft1 ? "0px" : "calc(100% - 45px)",
                            transition:
                              "left 0.8s ease, background-color 0.3s ease",
                            padding: "14px",
                            borderRadius: "50%",
                          }}>
                          <FaAnglesLeft />
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Second Modal [alredy model open ] - Opens on Left Scroll */}
      {isModalOpen && (
        <div className="modal show d-block" style={{ width: "100%" }}>
          <div
            style={{ width: "70%", margin: "auto" }}
            className="modal-dialog"
            role="document">
            <div className="modal-content">
              <div className="modal-header">
                <button
                  type="button"
                  className="close"
                  onClick={() => setIsModalOpen(false)}>
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="w-100 d-flex align-center justify-content-center mb-4">
                  <img width={150} src="images/Logosmall.png" alt="Logo" />
                </div>
                <div className="container mt-4">
                  <div className="row">
                    {loading && !messageLeft && !messageLefterror && (
                      <div className="w-100 d-flex align-center justify-content-center mb-4">
                        <div className="text-center">
                          <div
                            className="spinner-border text-primary mb-3"
                            role="status"
                          />
                          <h5>Loading, please wait...</h5>
                        </div>
                      </div>
                    )}

                    {!loading && messageLeft && (
                      <>
                        <div className="w-100 d-flex align-center justify-content-center mb-4">
                          <img width={90} src="images/favicon.png" alt="Logo" />
                        </div>
                        <div className="w-100 d-flex align-center justify-content-center mb-4">
                          <h5 style={{ color: "#3a8524" }}>{messageLeft}</h5>
                        </div>
                      </>
                    )}

                    {!loading && messageLefterror && (
                      <>
                        <div className="w-100 d-flex align-center justify-content-center mb-4">
                          <img width={90} src="images/wrong.gif" alt="Logo" />
                        </div>
                        <div className="w-100 d-flex align-center justify-content-center mb-4">
                          <h5 style={{ color: "rgb(252 21 0)" }}>
                            {messageLefterror}
                          </h5>
                        </div>
                      </>
                    )}

                    <div className="button-container3 w-100 d-flex align-center justify-content-center mb-4">
                      <button
                        onClick={handleAllmodelclose1}
                        type="button"
                        className="btn p-3 rounded-pill responsive-btn3">
                        Scan Again
                      </button>
                      <button
                        onClick={handleclose2}
                        className="btn p-3 rounded-pill responsive-btn3">
                        Done
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* {isModalOpen && (
        <div className="modal show d-block" style={{ width: "100%" }}>
          <div style={{ width: "70%", margin: "auto" }} className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" onClick={() => setIsModalOpen(false)}>
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="w-100 d-flex align-center justify-content-center mb-4">
                  <img width={150} src="images/Logosmall.png" alt="Logo" />
                </div>
                <div className="container mt-4">
                  <div className="row">

                    {messageLeft && (
                      <>
                        <div className="w-100 d-flex align-center justify-content-center mb-4">
                          <img width={90} src="images/favicon.png" alt="Logo" />
                        </div>
                        <div className="w-100 d-flex align-center justify-content-center mb-4">
                          <h5 style={{ color: "#3a8524" }}>{messageLeft}</h5>
                        </div>
                      </>
                    )}

                    {messageLefterror && (
                      <>
                        <div className="w-100 d-flex align-center justify-content-center mb-4">
                          <img width={90} src="images/wrong.gif" alt="Logo" />
                        </div>
                        <div className="w-100 d-flex align-center justify-content-center mb-4">
                          <h5 style={{ color: "rgb(252 21 0)" }}>{messageLefterror}</h5>
                        </div>

                      </>
                    )}

                    <div className="button-container3 w-100 d-flex align-center justify-content-center mb-4">
                      <button
                        onClick={handleAllmodelclose1}
                        type="button"

                        className=" btn p-3 rounded-pill responsive-btn3"
                      >
                        Scan Again
                      </button>
                      <button
                        onClick={handleclose2}
                        className="btn p-3 rounded-pill responsive-btn3"
                      >
                        Done
                      </button>
                    </div>


                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )} */}
      {/* model thired 3 */}
      {isModalOpen3 && (
        <div className="modal show d-block" style={{ width: "100%" }}>
          <div
            style={{ width: "70%", margin: "auto" }}
            className="modal-dialog"
            role="document">
            <div className="modal-content">
              <div className="modal-header">
                <button
                  type="button"
                  className="close"
                  onClick={() => setIsModalOpen3(false)}>
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="w-100 d-flex align-items-center justify-content-center mb-4">
                  <img width={150} src="images/Logosmall.png" alt="Logo" />
                </div>

                {loading ? (
                  <div className="w-100 d-flex align-items-center justify-content-center mb-4">
                    <div className="text-center">
                      <div
                        className="spinner-border text-primary mb-3"
                        role="status"
                      />
                      <h5>Loading, please wait...</h5>
                    </div>
                  </div>
                ) : details && Array.isArray(details) && details.length > 0 ? (
                  <div
                    className="container-fluid mt-4 p-0 p-sm-2"
                    style={{ padding: "10px" }}>
                    {details.map((item, index) => (
                      <div key={index} className="mb-4 p-0 p-sm-3">
                        {/* First Row - Image and Product Details */}
                        <div className="row w-100 align-items-center">
                          <div className="col-6 d-flex justify-content-center">
                            <img
                              width={120}
                              className="rounded p-3"
                              src={item?.image_link || "images/abt_02.png"}
                              alt="Product"
                              style={{ borderRadius: "10px" }}
                            />
                          </div>
                          <div className="col-6 d-flex flex-column justify-content-center text-center text-md-end">
                            <p className="mb-0">
                              <strong>{item?.brand}</strong>
                            </p>
                            <p className="mb-0">
                              <strong>{item?.product}</strong>
                            </p>
                          </div>
                        </div>

                        {/* Second Row - Batch Name and Price */}
                        <div className="row w-100 align-items-center">
                          <div className="col-6 text-center text-md-start">
                            <p className="mb-0">
                              <strong>{item?.batch_name}</strong>
                            </p>
                          </div>
                          <div className="col-6 text-center text-md-end">
                            <p className="mb-0">
                              <strong>{item?.price}</strong>
                            </p>
                          </div>
                        </div>

                        {/* Third Row - Additional Info */}
                        <div className="row w-100 align-items-center">
                          <div className="col-6 text-center text-md-start">
                            <p className="mb-0">
                              <strong>{item?.other_one}</strong>
                            </p>
                          </div>
                          <div className="col-6 text-center text-md-end">
                            <p className="mb-0">
                              <strong>{item?.other_two}</strong>
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}

                    <div className="button-container3 w-100 d-flex align-center justify-content-center mb-4">
                      <button
                        onClick={handleAllmodelclose2}
                        type="button"
                        className="btn p-3 rounded-pill responsive-btn3">
                        Scan Again
                      </button>
                      <button
                        onClick={handleclose3}
                        className="btn p-3 rounded-pill responsive-btn3">
                        Done
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="container mt-4">
                    <div className="row">
                      {messageNew && (
                        <>
                          <div className="w-100 d-flex align-items-center justify-content-center mb-4">
                            <img
                              width={90}
                              src="images/favicon.png"
                              alt="Success"
                            />
                          </div>
                          <div className="w-100 d-flex align-items-center justify-content-center mb-4">
                            <h5 style={{ color: "#3a8524" }}>{messageNew}</h5>
                          </div>
                        </>
                      )}

                      {messageNewError && (
                        <>
                          <div className="w-100 d-flex align-items-center justify-content-center mb-4">
                            <img
                              width={90}
                              src="images/wrong.gif"
                              alt="Error"
                            />
                          </div>
                          <div className="w-100 d-flex align-items-center justify-content-center mb-4">
                            <h5 style={{ color: "rgb(252, 21, 0)" }}>
                              {messageNewError}
                            </h5>
                          </div>
                        </>
                      )}

                      <div className="button-container3 w-100 d-flex align-items-center justify-content-center mb-4">
                        <button
                          onClick={handleAllmodelclose2}
                          className="btn p-3 rounded-pill responsive-btn3">
                          Scan Again
                        </button>
                        <button
                          onClick={handleclose3}
                          className="btn p-3 rounded-pill responsive-btn3">
                          Done
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Download;
